import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { WHATSAPP_BASE, PHONE_RAW } from "../mock";

export default function WhatsAppButton() {
  const waUrl = `${WHATSAPP_BASE}?text=Hi!%20I'd%20like%20to%20enquire%20about%20therapy%20services%20at%20Nanhe%20Kadam.`;

  return (
    <>
      {/* Mobile / Tablet: split bottom bar - Call 50% + WhatsApp 50% */}
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-50 flex shadow-[0_-8px_24px_-12px_rgba(18,43,69,0.25)]">
        <a
          href={`tel:${PHONE_RAW}`}
          className="w-1/2 bg-[#122b45] hover:bg-[#0d2138] text-white flex items-center justify-center gap-2 py-3.5 text-sm font-semibold"
        >
          <Phone className="w-4 h-4" />
          Call Now
        </a>
        <a
          href={waUrl}
          target="_blank"
          rel="noreferrer"
          className="w-1/2 bg-[#25d366] hover:bg-[#20bd5a] text-white flex items-center justify-center gap-2 py-3.5 text-sm font-semibold"
        >
          <MessageCircle className="w-4 h-4" />
          WhatsApp
        </a>
      </div>

      {/* Desktop: small round WhatsApp floating button */}
      <a
        href={waUrl}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="hidden lg:flex fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25d366] hover:bg-[#20bd5a] text-white shadow-xl items-center justify-center transition hover:scale-105"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </>
  );
}
